import { memo } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { FileX2 } from 'lucide-react';

import ImportDialog from '../shared/ImportDialog';

const TITLE_ID = 'discard-import-title';

/**
 * "Discard this import?" confirmation shown when leaving the wizard with a file loaded.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onKeep Close and stay on the wizard.
 * @param {() => void} props.onDiscard Drop the import and leave.
 */
function DiscardImportModal({ isOpen, onKeep, onDiscard }) {
  const { t } = useTranslation('people-access');
  if (!isOpen) return null;

  return (
    <ImportDialog
      align="center"
      onClose={onKeep}
      titleId={TITLE_ID}
      title={t('import.discard.title')}
      closeAriaLabel={t('import.discard.close')}
      icon={
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-500/10 text-amber-500">
          <FileX2 size={20} aria-hidden />
        </span>
      }
      footer={
        <>
          <Button variant="secondary" customButtonHeight="!h-[40px]" className="!px-6" data-autofocus onClick={onKeep}>
            {t('import.discard.keep')}
          </Button>
          <Button variant="danger" customButtonHeight="!h-[40px]" className="!px-6" onClick={onDiscard}>
            {t('import.discard.confirm')}
          </Button>
        </>
      }
    >
      <p className="text-center text-sm text-content-secondary">{t('import.discard.message')}</p>
    </ImportDialog>
  );
}

export default memo(DiscardImportModal);
